import { createApp } from 'vue'
import App from './App.vue'
import router from "./router";
import AOS from 'aos'
import 'aos/dist/aos.css'
import i18n from './i18n'
import store from "./state/store";

import BootstrapVue3 from 'bootstrap-vue-3';
import vClickOutside from "click-outside-vue3"
import VueApexCharts from "vue3-apexcharts";
import Maska from 'maska';

import VueFeather from 'vue-feather';
import Particles from "particles.vue3";
import SockerMixin from "./mixins/SocketMixins"
// import VueLoadmore from 'vuejs-loadmore'

import '@/assets/scss/config/material/app.scss';
import '@vueform/slider/themes/default.css';

AOS.init({
    easing: 'ease-out-back',
    duration: 1000
})

const app = createApp(App)

app.config.warnHandler = (msg) => {
    if (msg.includes('expose() should be passed a plain object')) return;
}

app
    .use(store)
    .use(router)
    .use(VueApexCharts)
    .use(BootstrapVue3)
    .component(VueFeather.type, VueFeather)
    .use(Maska)
    .use(Particles)
    .use(i18n)
    .use(vClickOutside)
    .mixin(SockerMixin)
    .mount('#app')